/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPercentage0 = createReactComponent("outline", "percentage-0", "IconPercentage0", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }]]);

export { IconPercentage0 as default };
//# sourceMappingURL=IconPercentage0.mjs.map
